import { CircleAlert } from 'lucide-react';

const NoAPRs: React.FunctionComponent = function () {
  return (
    <div className="flex gap-x-3 p-3 md:p-4 bg-neutral-000 border border-red-200 rounded-lg mb-6">
      <CircleAlert
        className="stroke-red-200 mb-auto min-w-5 md:mt-px"
        size={20}
      />
      <div className="flex flex-col">
        <h2 className="text-14-22-b md:text-16-24-b mb-1">
          No finance rates available
        </h2>
        <h3 className="text-12-18 md:text-13-18 text-neutral-700">
          There are no valid finance rates available for this job. If you think
          this is an error, please reach out to Ideal4Finance
        </h3>
      </div>
    </div>
  );
};

export default NoAPRs;
